import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "施药人"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "施药人"
    },
    model: {
      value: _vm.searchForm.executeUserNickname,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "executeUserNickname", $$v);
      },
      expression: "searchForm.executeUserNickname"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _vm.buttonPerms(_vm.$route.path + ":add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.buttonPerms(_vm.$route.path + ":handle") && scope.row.state == "Wait" ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.handle(scope.row.id);
            }
          }
        }, [_vm._v("执行")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":edit") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":del") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row.id);
            }
          }
        }, [_vm._v("删除")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "batchCode",
      label: "养殖批次",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "species",
      label: "养殖品种",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "state",
      label: "任务状态",
      sortable: "custom",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.state == "Wait" ? _c("div", {
          staticClass: "text-lose"
        }, [_vm._v("待执行")]) : _vm._e(), scope.row.state == "End" ? _c("div", {
          staticClass: "text-suggest"
        }, [_vm._v("已执行")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "executeContent",
      label: "病害情况",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "executeUserNickname",
      label: "施药人",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "executeDate",
      label: "施药日期",
      sortable: "custom",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.dayjs(scope.row.executeDate).format("YYYY-MM-DD HH:mm:ss")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "labName",
      label: "所属企业",
      sortable: "custom",
      "min-width": "120",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "areaName",
      label: "所属养殖区域",
      sortable: "custom",
      "min-width": "140",
      "show-overflow-tooltip": ""
    }
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属企业",
      "label-width": _vm.formLabelWidth,
      prop: "labId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属企业"
    },
    model: {
      value: _vm.formData.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "labName", $$v);
      },
      expression: "formData.labName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      disabled: _vm.formData.createTime,
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.lab_show = !_vm.lab_show;
      }
    }
  }, [_vm._v("选择")])], 1)])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属养殖区域",
      "label-width": _vm.formLabelWidth,
      prop: "areaId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属养殖区域"
    },
    model: {
      value: _vm.formData.areaName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "areaName", $$v);
      },
      expression: "formData.areaName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      disabled: _vm.formData.createTime,
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.areaClick
    }
  }, [_vm._v("选择")])], 1)])], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "施药人",
      "label-width": _vm.formLabelWidth,
      prop: "executeUser"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择施药人"
    },
    model: {
      value: _vm.formData.executeUserNickname,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeUserNickname", $$v);
      },
      expression: "formData.executeUserNickname"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: _vm.userClick
    }
  }, [_vm._v("选择")])], 1)])], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "施药日期",
      "label-width": _vm.formLabelWidth,
      prop: "executeDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "请选择施药日期",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.formData.executeDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeDate", $$v);
      },
      expression: "formData.executeDate"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "病害情况",
      "label-width": _vm.formLabelWidth,
      prop: "executeContent"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      placeholder: "请输入病害情况"
    },
    model: {
      value: _vm.formData.executeContent,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "executeContent", $$v);
      },
      expression: "formData.executeContent"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "使用药品",
      "label-width": _vm.formLabelWidth,
      prop: "items"
    }
  }, [_c("el-button", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.itemsAdd();
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.formData.items,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.itemsAdd(scope.row, scope.$index);
            }
          }
        }, [_vm._v("编")]), _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.itemsDel(scope.$index);
            }
          }
        }, [_vm._v("删")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "药品名称",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "specs",
      label: "药品规格",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "amount",
      label: "使用数量",
      width: "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "unit",
      label: "单位",
      width: "80",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "source",
      label: "药品来源",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  })], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("el-dialog", {
    staticClass: "items-dialog",
    attrs: {
      visible: _vm.itemsAddDialogShow,
      title: "新增使用药品",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.itemsAddDialogShow = $event;
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.items_formData,
      rules: _vm.items_rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "药品名称",
      "label-width": _vm.formLabelWidth,
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入名称"
    },
    model: {
      value: _vm.items_formData.name,
      callback: function callback($$v) {
        _vm.$set(_vm.items_formData, "name", $$v);
      },
      expression: "items_formData.name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "药品规格",
      "label-width": _vm.formLabelWidth,
      prop: "specs"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入规格"
    },
    model: {
      value: _vm.items_formData.specs,
      callback: function callback($$v) {
        _vm.$set(_vm.items_formData, "specs", $$v);
      },
      expression: "items_formData.specs"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "使用数量",
      "label-width": _vm.formLabelWidth,
      prop: "amount"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入数量"
    },
    model: {
      value: _vm.items_formData.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.items_formData, "amount", $$v);
      },
      expression: "items_formData.amount"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "单位",
      "label-width": _vm.formLabelWidth,
      prop: "unit"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入单位"
    },
    model: {
      value: _vm.items_formData.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.items_formData, "unit", $$v);
      },
      expression: "items_formData.unit"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "药品来源",
      "label-width": _vm.formLabelWidth,
      prop: "source"
    }
  }, [_c("el-input", {
    attrs: {
      autocomplete: "off",
      placeholder: "请输入来源"
    },
    model: {
      value: _vm.items_formData.source,
      callback: function callback($$v) {
        _vm.$set(_vm.items_formData, "source", $$v);
      },
      expression: "items_formData.source"
    }
  })], 1)], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.itemsAddDialogShow = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.itemsSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _c("el-dialog", {
    attrs: {
      visible: _vm.handleDialogShow,
      title: "执行任务",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.handleDialogShow = $event;
      },
      close: function close($event) {
        _vm.handleData = {};
      }
    }
  }, [_c("el-form", {
    ref: "handleformDataVerify",
    attrs: {
      model: _vm.handleData,
      rules: _vm.handleRules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "操作时间",
      "label-width": _vm.formLabelWidth,
      prop: "operateDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      type: "datetime",
      placeholder: "请选择操作时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.handleData.operateDate,
      callback: function callback($$v) {
        _vm.$set(_vm.handleData, "operateDate", $$v);
      },
      expression: "handleData.operateDate"
    }
  })], 1)], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "操作内容",
      "label-width": _vm.formLabelWidth,
      prop: "operateContent"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 5,
      placeholder: "请输入操作内容"
    },
    model: {
      value: _vm.handleData.operateContent,
      callback: function callback($$v) {
        _vm.$set(_vm.handleData, "operateContent", $$v);
      },
      expression: "handleData.operateContent"
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        ;
        _vm.handleDialogShow = false, _vm.handleData = {};
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitHandleData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm.lab_show ? _c("labSel", {
    on: {
      "child-lab-sel": _vm.labSel
    }
  }) : _vm._e(), _vm.area_show ? _c("areaSel", {
    attrs: {
      searchKey: "Cistern,Pond",
      labId: _vm.formData.labId || ""
    },
    on: {
      "child-area-sel": _vm.areaSel
    }
  }) : _vm._e(), _vm.user_show ? _c("userSel", {
    on: {
      "child-user-sel": _vm.userSel
    }
  }) : _vm._e(), _vm.plan_show ? _c("planSel", {
    attrs: {
      labId: _vm.formData.labId || "",
      areaId: _vm.formData.areaId || ""
    },
    on: {
      "child-plan-sel": _vm.planSel
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };